var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3307 10.0156V12.7693C17.3307 13.1427 17.3307 13.3294 17.4034 13.472C17.4673 13.5974 17.5693 13.6994 17.6947 13.7633C17.8373 13.836 18.024 13.836 18.3974 13.836H21.1511M17.3307 19.8359H13.3307M18.6641 17.1693H13.3307M21.3307 15.1614V19.9693C21.3307 21.0894 21.3307 21.6494 21.1127 22.0773C20.921 22.4536 20.615 22.7595 20.2387 22.9513C19.8109 23.1693 19.2508 23.1693 18.1307 23.1693H13.8641C12.744 23.1693 12.1839 23.1693 11.7561 22.9513C11.3798 22.7595 11.0738 22.4536 10.882 22.0773C10.6641 21.6494 10.6641 21.0894 10.6641 19.9693V13.0359C10.6641 11.9158 10.6641 11.3558 10.882 10.928C11.0738 10.5516 11.3798 10.2457 11.7561 10.0539C12.1839 9.83594 12.744 9.83594 13.8641 9.83594H16.0052C16.4944 9.83594 16.739 9.83594 16.9692 9.8912C17.1733 9.94019 17.3684 10.021 17.5473 10.1307C17.7491 10.2543 17.9221 10.4273 18.268 10.7732L20.3935 12.8987C20.7394 13.2446 20.9123 13.4175 21.036 13.6194C21.1457 13.7983 21.2265 13.9934 21.2755 14.1975C21.3307 14.4276 21.3307 14.6722 21.3307 15.1614Z",
    stroke: "#D92D20",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile05);
export default __webpack_public_path__ + "static/media/file-05.dcf611ca2299a145c90b09cef64c1964.svg";
export { ForwardRef as ReactComponent };